class SparkContainerCtrl {
  constructor(EventService, $scope, $document) {
    'ngInject';
    this.es = EventService;
    this.$scope = $scope;
    this.$document = $document;

    this.toolCards = [
      { id: "createTemplateFromPrompt", name: "Create Template", icon: "fa fa-plus", description: "Create a new Template." },
      { id: "updateTemplateFromPrompt", name: "Update Template", icon: "fa fa-edit", description: "Update an existing Template." }
    ];
    this.tool = null;
    this.syncFields = [];
  }

  $onInit() {
    this.$scope.$watch(
      () => this.show,
      (newVal, _oldVal) => {
        if (newVal) {
          // Temporary solution before go-live, needs more analysis
          const activeTool = this.hasTemplateContent() ? 
            this.toolCards.find(t => t.id === 'updateTemplateFromPrompt') :
            this.toolCards.find(t => t.id === 'createTemplateFromPrompt');
          this.selectTool(activeTool);
        }
      }
    );
  }

  getDynamicBuilderCtrl() {
    const el = this.$document[0].querySelector('dynamic-builder');
    if (!el) return null;
    return angular.element(el).controller('dynamicBuilder') || null;
  }

  hasTemplateContent() {
    const ctrl = this.getDynamicBuilderCtrl();
    const raw = ctrl ? ctrl.dynamicContent : undefined;
    if (raw == null) return false;
    const content = typeof raw === 'string' ? raw : String(raw);
    const stripped = content.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').trim();
    return stripped.length > 0;
  }

  close() {
    this.show = false;
  }

  selectTool(card) {
    this.tool = card;
  }

  onTemplateCreated() {
    // Only transition if you were on the create tool
    if (!this.tool || this.tool.id !== 'createTemplateFromPrompt') return;

    const next = (this.toolCards || []).find(t => t.id === 'updateTemplateFromPrompt');
    if (next) this.selectTool(next);
  }
}

export default {
  bindings: {
    show: "="
  },
  templateUrl: 'dynamic-builder/spark-container/spark-container.component.html',
  controller: SparkContainerCtrl
};
